(function () {
  function init(root) {
    if (!root || root.dataset.nxInit) return;
    root.dataset.nxInit = '1';
    var seuil = parseInt(root.getAttribute('data-seuil'), 10) || 0;
    var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    var sid = root.getAttribute('data-section');

    /* Barre sticky mobile */
    var bar = document.getElementById('nx-sticky-' + sid);
    var hero = document.getElementById('nx-hero');
    var grid = document.getElementById('nx-grid');
    if (bar && hero && 'IntersectionObserver' in window) {
      var heroVisible = true, gridVisible = false;
      var upd = function () { bar.classList.toggle('is-visible', !heroVisible && !gridVisible); };
      new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; upd(); }).observe(hero);
      if (grid) new IntersectionObserver(function (e) { gridVisible = e[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(grid);
    } else if (bar) { bar.classList.add('is-visible'); }

    /* Copier le code promo */
    root.querySelectorAll('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy');
        var done = function () { btn.textContent = 'Copié ✓'; setTimeout(function () { btn.textContent = 'Copier'; }, 2000); };
        if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
      });
    });

    /* Ajout au panier sans quitter la page */
    var toast = document.getElementById('nx-toast');
    if (!toast) return;
    var timer;
    function closeToast() { toast.classList.remove('is-open'); }
    toast.querySelectorAll('[data-toast-close]').forEach(function (b) { b.addEventListener('click', closeToast); });
    function openToast(title, img, cart) {
      document.getElementById('nx-toast-name').textContent = title || '';
      var im = document.getElementById('nx-toast-img');
      if (img) { im.src = img; im.style.display = ''; } else { im.style.display = 'none'; }
      var ship = document.getElementById('nx-toast-ship');
      var fill = document.getElementById('nx-toast-bar');
      if (seuil > 0 && cart) {
        var reste = seuil - cart.total_price;
        if (reste > 0) {
          ship.classList.remove('is-ok');
          ship.innerHTML = 'Plus que <strong>' + fmt.format(reste / 100) + '</strong> pour la livraison offerte';
        } else {
          ship.classList.add('is-ok');
          ship.innerHTML = '<strong>✓ Livraison offerte</strong> sur votre commande';
        }
        fill.style.width = Math.min(100, Math.round(cart.total_price / seuil * 100)) + '%';
      }
      toast.classList.add('is-open');
      clearTimeout(timer);
      timer = setTimeout(closeToast, 7000);
    }
    root.querySelectorAll('form.nx-ajax').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        if (!window.fetch || !window.FormData) return;
        ev.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        if (btn) btn.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('cart-icon').forEach(function (el) { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(cart.item_count); });
            var box = form.closest('.nx-card, .nx-pack');
            var pic = box ? box.querySelector('img') : null;
            var img = pic ? (pic.currentSrc || pic.src) : '';
            var title = form.getAttribute('data-title') || (box && box.querySelector('h2, h3') ? box.querySelector('h2, h3').textContent : '');
            openToast(title, img, cart);
          })
          .catch(function () { form.submit(); })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }
  function boot() { document.querySelectorAll('.nx[data-seuil]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
